// engines/entitlement-source.js — the source seam (one indirection).
//
// `entitlement-service.js` imports `fetchEntitlement` from HERE and never has
// to know whether it's talking to the dev stub or the live `/entitlements`
// fetch. Brief 005b swaps the live implementation in without touching the
// service or this seam's public shape.
//
// Tree-shaking contract (Brief 005a success criterion #6): the dev stub must
// NOT appear in the production bundle. `__IS_LOCAL_DEV__` is replaced with the
// literal `false` by esbuild's `define` in production (build.mjs); the
// resulting `if (false) { … }` branch — and the dynamic `import()` inside it —
// is dead-code-eliminated, so `entitlement-source.dev.js` is never bundled.
// In unbundled dev (raw source served from the project root) the define is
// absent, so we fall back to a hostname check — hence the `typeof` guard, the
// same pattern `data/media-paths.js` uses for `__CONTENT_BASE__`.

/** @typedef {import("./entitlement-service.js").EntitlementStatus} EntitlementStatus */
/** @typedef {{ access: boolean, status?: EntitlementStatus }} EntitlementResult */

const IS_LOCAL_DEV =
  typeof __IS_LOCAL_DEV__ !== "undefined" ? __IS_LOCAL_DEV__ : isDevHost();

/** True on local dev hosts (mirrors sw.js `isDevHost`). */
function isDevHost() {
  const h = typeof location !== "undefined" ? location.hostname : "";
  return (
    h === "localhost" ||
    h.endsWith(".localhost") ||
    h === "127.0.0.1" ||
    h === "::1" ||
    h === "[::1]"
  );
}

/**
 * Fetch the current entitlement from whichever concrete source applies.
 *
 * @returns {Promise<EntitlementResult>}
 */
export async function fetchEntitlement() {
  if (IS_LOCAL_DEV) {
    const mod = await import("./entitlement-source.dev.js");
    return mod.fetchEntitlement();
  }
  const mod = await import("./entitlement-source.live.js");
  return mod.fetchEntitlement();
}
